<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>HPI Extract - Generate Export File </v-card-title>
          <v-card-text>
            <v-alert type="error" :value="!isDownloading && !!extractError">
              <p>Unable to Generate Export File:</p>
              <ul>
                <li>
                  {{ extractError }}
                </li>
              </ul>
            </v-alert>
            <p>
              <v-progress-linear
                :value="downloadProgress"
                :active="isDownloading"
                striped
                height="1em"
              />
            </p>

            <v-btn
              @click="getExtractFile"
              :loading="isDownloading"
              v-if="!theExtractFilename"
            >
              <span> Generate... </span>
              <v-icon>download</v-icon>
            </v-btn>

            <div v-if="theExtractFile">
              <v-icon>download</v-icon>
              <a
                :download="theExtractFilename"
                :href="theExtractFileDownloadLink"
                v-if="theExtractFileDownloadLink"
              >
                {{ theExtractFilename }}
              </a>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <v-card>
          <v-card-title>HPI Extract - Upload Response </v-card-title>
          <v-card-text>
            <div v-if="!!importSuccess">
              <v-alert type="success" :value="true">
                Import Sucessful. The following records were updated:
              </v-alert>
              <v-data-table
                :items="importSuccess"
                :headers="[
                  { text: 'Reg Num', value: 'RegistrationNo' },
                  { text: 'First Name', value: 'FirstName' },
                  { text: 'Last Name', value: 'Surname' },
                  { text: 'CPN', value: 'CPN' },
                ]"
              >
                <template #no-data><div>No records changed</div> </template>
              </v-data-table>
              <v-btn @click="importSuccess = null">Import another...</v-btn>
            </div>
            <div v-else>
              <v-alert
                type="error"
                :value="true"
                v-if="!isImporting && !!importError"
              >
                <p>Problems importing data:</p>
                <ul>
                  <li>
                    {{ importError }}
                  </li>
                </ul>
              </v-alert>
              <v-file-input
                v-model="theImportFile"
                label="Select the .xml file to Import"
                accept=".xml"
                @change="selectImportFile"
              >
              </v-file-input>
              <!-- <div>
                <v-textarea
                  v-model="theImportFileContents"
                  auto-grow
                  rows="1"
                  label="XML"
                  placeholder="Edit XML contents in here"
                >
                </v-textarea>
              </div> -->
              <v-btn
                @click="uploadImportFile"
                :loading="isImporting"
                :disabled="!theImportFileContents"
              >
                <span> Import Response </span>
                <v-icon>upload</v-icon>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HpiImportExport",
  data() {
    return {
      importError: null,
      theImportFile: null,
      theImportFileContents: null,
      isImporting: false,
      extractError: null,
      theExtractFile: null,
      isDownloading: false,
      importSuccess: false,
      downloadProgress: 0,
    };
  },
  methods: {
    async getExtractFile() {
      try {
        this.isDownloading = true;
        this.extractError = false;
        this.startDownloadProgress();
        const file = await this.$http.get("reports/hpiExtract");

        this.theExtractFile = file.data;
      } catch (e) {
        this.extractError = e.message;
      } finally {
        this.isDownloading = false;
      }
    },

    startDownloadProgress() {
      this.downloadProgress = 0;

      this.incrementDownloadProgress();
    },
    incrementDownloadProgress() {
      if (this.downloadProgress > 99) {
        return;
      }
      this.downloadProgress++;
      setTimeout(() => {
        this.incrementDownloadProgress();
      }, 1200);
    },
    async selectImportFile() {
      this.theImportFileContents = await this.theImportFile.text();
    },
    async uploadImportFile() {
      try {
        this.isImporting = true;
        this.importError = false;

        console.log("filecontents: ", { xml: this.theImportFileContents });

        const result = await this.$http.post("reports/hpiExtract", {
          xml: this.theImportFileContents,
        });
        console.log("success: ", result);
        this.importSuccess = result.data;
      } catch (e) {
        this.importError = e.message;
      } finally {
        this.isImporting = false;
      }
    },
  },
  computed: {
    theExtractFileDownloadLink() {
      if (!this.theExtractFile) {
        return "";
      }
      return `data:text/xml,` + encodeURIComponent(this.theExtractFile);
    },
    theExtractFilename() {
      if (!this.theExtractFile) {
        return "";
      }
      return `hpi-pcnz-extract-${this.$moment().toISOString()}.xml`;
    },
  },
};
</script>
